import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PagesComponent } from './pages/pages.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { NgCircleProgressModule } from 'ng-circle-progress';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';



import { DisplayService } from './services/display.service';
import { AppStateService } from './services/app-state.service';


// material modules
import { MatStepperModule } from '@angular/material/stepper';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//pipes
import { SafePipe } from './pipes/safe.pipe';
import { CasePipe } from './pipes/case.pipe';

// services
import { WidgetService } from './services/widget.service';

// components
import { PreQuestionsComponent } from './pages/pre-steps/pre-questions/pre-questions.component';
import { ResultsComponent } from './components/results/results.component';
import { StepsComponent } from './components/steps/steps.component';
import { QuizComponent } from './pages/quiz/quiz.component';
import { HomeComponent } from './pages/home/home.component';
import { QuizResultComponent } from './pages/quiz-result/quiz-result.component';

import { ResultProgressComponent } from './components/result-progress/result-progress.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { FinalResultComponent } from './pages/final-result/final-result.component';
import { EmailRedirectComponent } from './pages/email-redirect/email-redirect.component';
import { RunScriptsDirective } from './directives/run-scripts.directive';


@NgModule({
  declarations: [
    AppComponent,
    PagesComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    HomeComponent,
    StepsComponent,
    PreQuestionsComponent,
    ResultsComponent,
    QuizComponent,
    QuizResultComponent,
    ResultProgressComponent,
    PrivacyPolicyComponent,
    FinalResultComponent,
    SafePipe,
    CasePipe,
    EmailRedirectComponent,
    RunScriptsDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgbModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatStepperModule,
    MatButtonModule,
    MatProgressBarModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    NgCircleProgressModule.forRoot({}),
  ],
  providers: [DisplayService,
    AppStateService, {
      provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
    },
    WidgetService],
  bootstrap: [AppComponent]
})
export class AppModule { }
